import { patchRequest, getRequest, postRequest } from 'apis/ApiInstence';
import { put } from 'redux-saga/effects';
import { successGameBid, failedGameBid } from 'slice/gamebidSlice';

export function* updateGameBidAPI({ payload }) {
    try {
      yield patchRequest(`gamebid/${payload.id}`, payload.data);
      const response = yield getRequest('gamebid');
      if (response?.status == 200) {
        yield put(successGameBid(response?.data));
      } else {
        yield put(failedGameBid(response));
      }
    } catch (error) {
      console.log(error)
      // toast('resposnse.message')
    }
  }

   export function* getGamebidAPI({ payload }) {
    try {
      const response = yield getRequest('gamebid', payload);
      if (response?.status == 200) {
        yield put(successGameBid(response?.data));
      } else {
        yield put(failedGameBid(response));
      }
    } catch (error) {
      console.log(error)
      // toast('resposnse.message')
    }
  }

  export function* postGameWinningAPI({ payload }) {
    try {
      const response = yield postRequest('customer/bidwinner', payload);
      if (response?.status == 200) {
        yield put(successGameBid(response?.data));
      } else {
        yield put(failedGameBid(response));
      }
    } catch (error) {
      console.log(error)
      // toast('resposnse.message')
    }
  }
  